import * as turf from '@turf/turf';
import { LAT_LON_POINT_CLAZZ_VALUE, LatLonPoint } from 'app/model/CORE';

export default class TurfUtils {
    static toLatLonPoint(position: turf.Position): LatLonPoint {
        return {
            clazz: LAT_LON_POINT_CLAZZ_VALUE,
            latitude: position[1],
            longitude: position[0],
        };
    }

    static toPoint(input: LatLonPoint): turf.Feature<turf.Point> {
        return turf.point(TurfUtils.toPosition(input));
    }

    static toLineString(start: LatLonPoint, end: LatLonPoint): turf.Feature<turf.LineString> {
        return turf.lineString([TurfUtils.toPosition(start), TurfUtils.toPosition(end)]);
    }

    // GeoJSON expects [longitude, latitude] ordering of coordinate pairs
    static toPosition(input: LatLonPoint): turf.Position {
        return [input.longitude, input.latitude];
    }
}
